<template>
	<div>
		<div class="common-form">添加城市</div>
		<!-- 请输入内容 -->
		<el-input v-model="city" class="max-w460" placeholder="请输入内容要添加的城市"></el-input>
		<el-button size="small" type="primary" icon="el-icon-plus" @click="add_city">添加城市</el-button>
		<!-- 城市列表 -->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="getData" border style="width: 100%" v-loading="loading">
					<el-table-column prop="city" label="已添加的城市"></el-table-column>
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button @click="deleteClick(scope.row.serviceCityId)" type="danger" size="small">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!--分页-->
		<div class="pagination">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
				:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				:total="totalDataNumber">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Technician from '@/api/technician.js'
	export default {
		data() {
			return {
				city: '',
				/*是否加载完成*/
				loading: true,
				/*列表数据*/
				getData: [],
				/*门店列表数据*/
				storeList: [],
				/*一页多少条*/
				pageSize: 15,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
			}
		},
		created() {
			this.get_city()
		},
		methods: {
			/*选择第几页*/
			handleCurrentChange(val) {
				this.curPage = val;
				this.loading = true;
				this.get_city();
			},

			/*每页多少条*/
			handleSizeChange(val) {
				this.curPage = 1;
				this.pageSize = val;
				this.get_city();
			},

			// 添加城市
			add_city() {
				let {
					city
				} = this
				if (this.city == '') {
					this.$message({
						message: '请手动添加城市',
						type: 'warning'
					})
					return
				}
				Technician.addCity({
						city
					}, true)
					.then(data => {
						if (data.code == 1) {
							this.get_city()
							this.city = ''
							this.$message({
								message: data.msg,
								type: 'success'
							})
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			// 获取城市列表
			get_city() {
				let page = this.curPage;
				let pageSize = this.pageSize;
				Technician.getCity({
						page,
						pageSize
					}, true)
					.then(data => {
						this.loading = false;
						if (data.code == 1) {
							this.getData = data.data.data
							this.totalDataNumber = data.data.total;
						}
					})
					.catch(err => {
						this.loading = false;
						console.log(err)
					})
			},
			// 删除城市
			deleteClick(e) {
				let serviceCityId = e
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					self.loading = true;
					Technician.deleteCity({
							serviceCityId
						}, true)
						.then(data => {
							this.get_city()
							console.log(data)
						})
						.catch(err => {
							console.log(err)
						})
				}).catch(() => {
					self.loading = false;
				});
			}
		}
	}
</script>

<style scoped>
	.product-content {
		margin-top: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/supplier/setcity/index.vue